import { connect } from 'react-redux'

import { findCinemaId, findEventId } from '../global/helpers'
import { getCinemaSlug } from '../pages/Hall/helpers'

const mapStateToProps = (state) => {
    const cinemaid = findCinemaId(state)
    const eventid = findEventId(state)

    const site = cinemaid ? getCinemaSlug(cinemaid) : null

    return {
        isClubMember: state?.services?.user?.loyalty_program?.card?.is_valid,
        eventid: eventid,
        site: site,
    }
}

const hocRouter = (InnerComponent) => connect(mapStateToProps)(InnerComponent)

export default hocRouter
